<template>
    <div>
        <transition name="dialogfade">
            <k-dialog v-if="showDialog"
                class="edit-condition-dialog loan-notes-dialog"
                :title="'File Notes'"
                @close="closeDialog">
                <loan-notes-component :loan-id="loanId"></loan-notes-component>
            </k-dialog>
        </transition>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';

    import loanNotesComponent from './loanNotesComponent.vue';

    export default {
        props: ['loanId', 'showDialog'],
        emits: ['dialogclosed'],
        data() {
            return {      
            }
        },
        methods: {
            closeDialog() {
                this.$emit('dialogclosed');
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'loan-notes-component': loanNotesComponent
        }
    }
</script>

<style>
    @import '/src/assets/css/loanNotesDialog.css';
</style>